module.exports = __webpack_public_path__ + "img/queues.41c991f5.svg";